class ColorUtil {
  public transparent = 'transparent';
  public gray15 = '#ebebeb';
  public gray100 = '#444444';
  public gray75 = '#888888';
  public gray50 = '#2b2b2b';
  public gray30 = 'rgba(43, 43, 43, 0.3)';
  public lightGray = '#d3d3d3';
  public black4 = 'rgba(0, 0, 0, 0.4)';
  public black23 = 'rgba(0, 0, 0, 0.23)';
  public black73 = 'rgba(0, 0, 0, 0.73)';
  public white20 = 'rgba(255, 255, 255, 0.2)';
  public red53 = '#ff6753';
  public red60 = '#ff8383';
  public red80 = '#F4513B';
  public red90 = '#dc3544';
  public black = 'black';
  public white = 'white';

  public circleIcon = '#30BDE9';
  public heartIcon = '#F79BBC';
  public starIcon = '#E9B430';

  public couponSample = '#FED56F';

  public errorText = '#d32f2f';
}

export const colorUtil = new ColorUtil();
